import { MarketEvidencePendingProfiles } from '@/components/deals/evidence/MarketEvidencePendingProfiles'
import { MarketEvidenceSummary } from '@/components/deals/evidence/MarketEvidenceSummary'

export function MarketEvidenceOverview({
  groups,
  pendingProfileIds,
  profileLabels,
  profiles,
  unavailableProfileIds,
}) {
  const displayedProfileKeys = groups.map((group) => group.profileKey)

  return (
    <div className="space-y-5">
      {groups.map((group) => (
        <section
          key={group.profileKey}
          aria-labelledby={`evidence-overview-${group.profileId}`}
        >
          <h4
            id={`evidence-overview-${group.profileId}`}
            className="mb-3 font-bold text-foreground"
          >
            {group.profileLabel}
          </h4>
          <div className="grid gap-3 lg:grid-cols-3">
            {group.categories.map((category) => (
              <MarketEvidenceSummary
                key={`${category.category}-${category.profileId || 'subject'}`}
                category={category}
              />
            ))}
          </div>
        </section>
      ))}
      <MarketEvidencePendingProfiles
        hiddenProfileKeys={displayedProfileKeys}
        profileIds={pendingProfileIds}
        profileLabels={profileLabels}
        profiles={profiles}
      />
      <MarketEvidencePendingProfiles
        hiddenProfileKeys={displayedProfileKeys}
        profileIds={unavailableProfileIds}
        profileLabels={profileLabels}
        profiles={profiles}
        status="unavailable"
      />
    </div>
  )
}
